import { loadMore as loadMore_1 } from 'owa-locstrings/lib/strings/loadmore.locstring.json';
import { loading } from 'owa-locstrings/lib/strings/loading.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47781 */
import busStopStateToIconUrlConverter from '../utils/busStopStateToIconUrlConverter';
import { observer } from 'mobx-react-lite';
import { IButtonStyles } from 'office-ui-fabric-react/lib';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner } from 'office-ui-fabric-react/lib/Spinner';
import { ClientItemId } from 'owa-client-ids';
import { BusStopState } from 'owa-mail-list-store';
import loadMore from 'owa-mail-reading-pane-store/lib/actions/loadMore';

import * as React from 'react';

export interface MailListItemExpansionLoadMoreButtonProps {
    conversationId: ClientItemId;
    isLoadMoreInProgress: boolean;
    isSingleLineView: boolean;
    showBusStop: boolean;
}

const styles = require('./MailListItemExpansionLoadMoreButton.scss');
const classNames = require('classnames');

export default observer(function MailListItemExpansionLoadMoreButton(
    props: MailListItemExpansionLoadMoreButtonProps
) {
    const loadMoreStyles: IButtonStyles = {
        root: styles.loadCommon,
        textContainer: styles.loadMoreText,
        label: styles.loadMoreButtonLabel,
    };

    // load more button has a NoStop bus stop state
    const busStopIcon = busStopStateToIconUrlConverter(BusStopState.NoStop);
    const showBusStop = props.showBusStop;

    return (
        <div className={styles.loadMoreContainer}>
            <img
                className={classNames(
                    props.isSingleLineView
                        ? styles.busStopContainerSingleLine
                        : styles.busStopContainerThreeColumn,
                    !showBusStop && styles.busStopPlaceHolder
                )}
                src={showBusStop ? busStopIcon : undefined}
            />

            {props.isLoadMoreInProgress ? (
                <div className={styles.loadCommon}>
                    <div className={styles.loadingFlexContainer}>
                        <Spinner />
                        <span className={styles.loadingText}>{loc(loading)}</span>
                    </div>
                </div>
            ) : (
                <DefaultButton
                    onClick={evt => onLoadMore(evt, props.conversationId)}
                    styles={loadMoreStyles}
                    text={loc(loadMore_1)}
                />
            )}
        </div>
    );
});

const onLoadMore = (event: React.MouseEvent<unknown>, conversationId: ClientItemId) => {
    event.stopPropagation();
    loadMore(conversationId);
};
